const partnerEnv = require('./config/partner')
const loaderSettings = require('./config/loader')
const flowSettings = require('./config/settings')
const flowVariants = require('./config/variants')
const { chapters } = require("./config/header");

let config = {
  ...partnerEnv,
  loader: loaderSettings,
  settings: flowSettings,
  variants: flowVariants,
  // testScreen: 'city',
  path: (i18n) => ([
    {
      path: '/chapter1',
      params: {
        header: chapters.first(i18n),
      },
      screens: [
        {
          type: 'email',
          params: {
            collectBlackbox: true
          }
        },
        {
          type: 'GDPR',
          params: {
            screenHeader: (store) => ({
              title: i18n.t("overview:consent_header_title"),
            }),
          }
        }
      ]
    },
    {
      path: '/chapter2',
      params: {
        header: chapters.second(i18n),
      },
      screens: [
        {
          type: 'password-animated',
          params: {
            checkBlackBoxInIovation: true,
            conditions: [
              {
                property: 'socialMediaData.socialSignIn',
                value: false
              },
              {
                property: "user.reactivated",
                value: false,
              },
            ]
          }
        },
        { type: 'email-validation', params: { validation: true } },
        {
          type: 'phone-number'
        },
      ]
    },
    {
      path: '/chapter3',
      params: {
        header: chapters.third(i18n),
      },
      screens: [
        {
          type: 'full-name',
          params: {
            conditions: [
              { property: 'app.country.code', not: true, value: 'JP' }
            ]
          }
        },
        {
          type: 'first-name.japan',
          params: {
            conditions: [
              { property: 'app.country.code', value: 'JP' }
            ]
          }
        },
        {
          type: 'last-name.japan',
          params: {
            conditions: [
              { property: 'app.country.code', value: 'JP' }
            ]
          }
        },
        {
          type: 'question.gender',
          params: {
            columns: true,
            text: () => i18n.t('gender:select_gender'),
            dispatchKey: 'updateUser',
            propertyName: 'gender',
            currentAnswer: (store) => store.state.user.gender,
            answers: () => ([
              { id: 'female', label: i18n.t('gender:female') },
              { id: 'male', label: i18n.t('gender:male') }
            ])
          }
        },
        {
          type: 'postal-code'
        },
        {
          type: 'question.province',
          params: {
            list: true,
            scrollShadow: true,
            text: () => i18n.t('postalCode:select_province'),
            dispatchKey: 'updateUser',
            propertyName: 'province',
            showKeyboardOnNextScreen: true,
            currentAnswer: (store) => store.state.user.province,
            answers: (store) => {
              return store.state.app.country.provinces.filter((item) => {
                return store.state.customData.hideSHProvince === true || (store.state.customData.hideSHProvince === undefined && store.state.partner.hideSHProvince === true)
                  ? item.ISOCode !== 'DE-SH' : true
              }).map(p => ({
                id: p.ISOCode.slice(-2),
                label: p.name
              }))
            },
            onSubmit: (answer, store) => {
              if (answer) {
                store.dispatch('updateUser', {
                  provinceCode: answer.id,
                  provinceName: answer.label,
                });
              }
            },
            conditions: [
              {
                property: 'user.province',
                value: false
              },
              {
                property: 'user.country',
                value: ['DE', 'CA']
              }
            ]
          }
        },
        {
          type: 'question.state',
          params: {
            list: true,
            scrollShadow: true,
            text: () => i18n.t('postalCode:select_province', { context: 'us' }),
            dispatchKey: 'updateUser',
            propertyName: 'province',
            currentAnswer: (store) => store.state.user.state,
            answers: (store) => {
              return store.state.app.country.provinces.map(p => ({
                id: p.ISOCode.slice(-2),
                label: p.name
              }))
            },
            conditions: [
              {
                property: 'user.province',
                value: false
              },
              {
                property: 'app.postalArea.streets',
                value: false
              },
              {
                property: 'app.country.code',
                value: 'US'
              }
            ]
          }
        },
        {
          type: 'city'
        },
        {
          type: 'street-name'
        },
        {
          type: 'house-number'
        },
        {
          type: 'masked-birthdate'
        },
        {
          type: 'password-animated.reactivated',
          params: {
            conditions: [
              {
                property: 'socialMediaData.socialSignIn',
                value: false
              },
              {
                property: "user.reactivated",
                value: true,
              },
            ]
          }
        },
        {
          type: 'phone-number-validation'
        },
        {
          type: 'sms-code',
          params: {
            hideBackButton: true,
            associatedPhoneNumberUrl: '/chapter3/phone-number-validation',
            conditions: [
              {
                property: 'app.otp.enabled',
                value: true
              }
            ]
          }
        }
      ]
    }
  ])
}

module.exports = config



// WEBPACK FOOTER //
// ./src/partners/partner.module.config.js